import type { ReactNode } from "react";

interface ModalFormSectionProps {
  title: string;
  children: ReactNode;
  columns?: 1 | 2;
  className?: string;
}

export function ModalFormSection({
  title,
  children,
  columns = 2,
  className,
}: ModalFormSectionProps): JSX.Element {
  return (
    <div className={`tw-space-y-4 ${className || ""}`}>
      <h3 className="tw-text-lg tw-font-semibold tw-text-primary">{title}</h3>
      <div
        className={
          columns === 2 ? "tw-grid tw-grid-cols-2 tw-gap-4" : "tw-space-y-4"
        }
      >
        {children}
      </div>
    </div>
  );
}
